module.exports = __webpack_public_path__ + "img/pos_dikemas.0e3a9043.png";